export const EMBEDDED_ONBOARDING_BEARER_STORAGE_KEY = 'embedded_onboarding_bearer'

export const getEmbeddedOnboardingToken = (): string | null => {
  try {
    return window.sessionStorage.getItem(EMBEDDED_ONBOARDING_BEARER_STORAGE_KEY)
  } catch {
    return null
  }
}
